import { Component } from 'vue';
import { ActiveModalActAccessStates } from '@/models/modal/modal.enum';
import { ProjectProductStateType } from '@studyportals/crm-data-processor-interface';

enum ActAddedUserTypes {
	VALID = 'valid',
	NOT_EMAIL = 'notEmail',
	ALREADY_ADDED = 'alreadyAdded'
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const ActDateTypes = {
	START: 'start',
	END: 'end'
} as const;

type ActDateType = (typeof ActDateTypes)[keyof typeof ActDateTypes];

interface IActUserToAdd {
	value: string;
	type: ActAddedUserTypes;
}

interface IActStatusFilterOption {
	label: string;
	value: ProjectProductStateType;
}

type TModalActAccessSteps = {
	[key in ActiveModalActAccessStates]: Component;
};

interface IDashboardAccessPeriodsValidationIssue {
	productId: string;
	field: ActDateType;
	message: string;
}

export {
	IActStatusFilterOption,
	TModalActAccessSteps,
	ActAddedUserTypes,
	IActUserToAdd,
	ActDateType,
	ActDateTypes,
	IDashboardAccessPeriodsValidationIssue
};
